import React, { useEffect, useState } from 'react';
import './ClickSpark.css';

const ClickSpark = ({ 
  color = '#ff6b35',
  particleCount = 12,
  particleSize = 4
}) => {
  const [sparks, setSparks] = useState([]);

  useEffect(() => {
    const handleClick = (e) => {
      const newSparks = Array.from({ length: particleCount }, (_, i) => ({
        id: Date.now() + i,
        x: e.clientX,
        y: e.clientY,
        angle: (360 / particleCount) * i,
      }));

      setSparks(prev => [...prev, ...newSparks]);

      // Remove sparks after animation
      setTimeout(() => {
        setSparks(prev => prev.filter(spark => !newSparks.find(s => s.id === spark.id)));
      }, 1000);
    };

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [particleCount]);

  return (
    <div className="click-spark-container">
      {sparks.map(spark => (
        <div
          key={spark.id}
          className="spark-particle"
          style={{
            left: `${spark.x}px`,
            top: `${spark.y}px`,
            '--angle': `${spark.angle}deg`,
            '--color': color,
            '--size': `${particleSize}px`,
          }}
        />
      ))}
    </div>
  );
};

export default ClickSpark;
